import React, { InputHTMLAttributes } from 'react';
import { AppTypography } from '../appUi';
import AppFieldLine from './AppFieldLine';
import AppInputLabel from './AppInputLabel';
import AppReadonlyField, { formatAppReadonlyValue } from './AppReadonlyField';
import styles from './AppFormInput.module.css';

interface AppFormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  required?: boolean;
  containerClassName?: string;
}

const AppFormInput: React.FC<AppFormInputProps> = ({
  label,
  error,
  required = false,
  id,
  containerClassName = '',
  className = '',
  readOnly,
  ...rest
}) => {
  const inputClassName = [styles.input, className].filter(Boolean).join(' ');
  const showRequired = required && !readOnly;

  if (readOnly) {
    return (
      <AppReadonlyField
        id={id}
        label={label}
        value={formatAppReadonlyValue(rest.value, rest.type)}
        containerClassName={containerClassName}
      />
    );
  }

  return (
    <div className={`${styles.container} ${containerClassName}`}>
      {label && <AppInputLabel htmlFor={id} required={showRequired}>{label}</AppInputLabel>}
      <input
        id={id}
        className={inputClassName}
        {...rest}
        required={showRequired}
        readOnly={readOnly}
        tabIndex={rest.tabIndex}
        aria-invalid={Boolean(error)}
      />
      <AppFieldLine error={Boolean(error)} />
      {error ? (
        <AppTypography variant="caption" className={styles.errorText}>
          {error}
        </AppTypography>
      ) : null}
    </div>
  );
};

export default AppFormInput;
